export default import.meta.ROLLDOWN_FILE_URL_AiLd5gOMPIKCr0hGhupNmg